import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import LaboratoryRequestCreateForm from './LaboratoryRequestCreateForm';
import LaboratoryRequestCreateWizard from '../LaboratoryRequestCreateWizard/LaboratoryRequestCreateWizard';

loadDOMComponent({
	selector: 'react-laboratory-request-create-dev',
	callback: ({ container, context, props }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<LaboratoryRequestCreateWizard
							onCreate={() => {}}
							formId='5e22e062-14c6-4a85-9cb3-a8dd7ccb1cfb'
							patientId='81f16d08-9855-4868-b703-a5a50d62b03f'
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
